import {useCallback} from 'react'
import {useDispatch} from 'react-redux'
import {fetchChainIdFromUrl, fetchUserNetwork} from '~/state/network'
import {useTranslation} from '~/contexts/Localization'
import useToast from './useToast'
import {useAccount, useNetwork, useSwitchNetwork} from "wagmi";

const useSwitchNetworkCustom = () => {
  const {address: account} = useAccount()
  const {chain} = useNetwork()
  const {chains, error, isLoading, pendingChainId, switchNetwork} =
    useSwitchNetwork()
  const dispatch = useDispatch()
  const {toastError} = useToast()

  const doSwitchNetwork = useCallback(
    async (userChainId: number) => {
      if (account && userChainId !== chain?.id && isLoading && pendingChainId === userChainId) {
        // const formattedChainId = `0x${userChainId.toString(16)}`
        try {
          switchNetwork?.(userChainId)
          // await provider.request({
          //   method: 'wallet_switchEthereumChain',
          //   params: [{chainId: formattedChainId}],
          // })
          dispatch(fetchChainIdFromUrl(false))
        } catch {
          // If the user doesn't have the chain add it
          // await provider.request({
          //   method: 'wallet_addEthereumChain',
          //   params: [CHAIN_PARAMS[userChainId]],
          // })
          dispatch(fetchChainIdFromUrl(false))
          try {
            // Prompt the user to switch after adding the chain
            // await provider.request({
            //   method: 'wallet_switchEthereumChain',
            //   params: [{chainId: formattedChainId}],
            // })
            dispatch(fetchChainIdFromUrl(false))
          } catch (error) {
            console.warn(error)
          }
        }
        reloadPage()
      } else {
        // dispatch(fetchUserNetwork(userChainId, account, chain?.id))
        switchNetwork?.(userChainId)
        // reloadPage()
      }
    },
    [chain?.id, account, isLoading, pendingChainId, dispatch],
  )
  return {switchNetwork: doSwitchNetwork}
}

const reloadPage = () => {
  // this is ugly but on the other side ensures that the network is properly injected
  window.location.reload()
}

export default useSwitchNetworkCustom
